<!--
  UploadStatusBar · 上传进度条（v-show: show）
  props: show / statusText / percent / errorMode
-->
<template>
  <div v-show="show" class="upload-box">
    <div class="row" style="gap:6px">
      <span class="chip" :class="{on: !errorMode}">{{ statusText }}</span>
    </div>
    <div class="progress" style="margin-top:6px">
      <span
        :style="{
          width: percent + '%',
          background: errorMode ? 'linear-gradient(90deg,#f87171,#b45)' : ''
        }"
      ></span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  show: { type: Boolean, default: false },
  statusText: { type: String, default: '待上传…' },
  percent: { type: Number, default: 0 },
  errorMode: { type: Boolean, default: false },
})
</script>

<style scoped>
.upload-box{flex:1;min-width:220px;max-width:360px}
</style>
